"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactPhoneNumberInput = _interopRequireWildcard(require("react-phone-number-input"));

require("react-phone-number-input/style.css");

var _styles = require("../styles");

var _style2 = require("./style");

var InputPhone = function InputPhone(_ref) {
  var defaultCountry = _ref.defaultCountry,
      error = _ref.error,
      id = _ref.id,
      placeholder = _ref.placeholder,
      value = _ref.value,
      onChange = _ref.onChange,
      required = _ref.required,
      disabled = _ref.disabled;

  var _useState = (0, _react.useState)((0, _reactPhoneNumberInput.formatPhoneNumberIntl)(value) || ''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentValue = _useState2[0],
      setCurrentValue = _useState2[1];

  var properSetCurrentValue = (0, _react.useCallback)(function (newValue) {
    setCurrentValue(newValue);
    onChange(newValue);
  }, [setCurrentValue, onChange]);
  return _react["default"].createElement(_style2.Container, null, required && _react["default"].createElement(_styles.Asterisk, {
    error: error,
    status: "default"
  }), _react["default"].createElement(_style2.InputContainer, {
    error: Boolean(error)
  }, _react["default"].createElement(_reactPhoneNumberInput["default"], {
    defaultCountry: defaultCountry,
    id: id,
    placeholder: placeholder,
    value: currentValue,
    onChange: properSetCurrentValue,
    disabled: disabled
  }), error && _react["default"].createElement("span", null, error)));
};

InputPhone.propTypes = {
  defaultCountry: _propTypes["default"].string,
  error: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
};
InputPhone.defaultProps = {
  defaultCountry: undefined,
  error: undefined,
  placeholder: undefined,
  onChange: undefined,
  value: undefined,
  required: false,
  disabled: false
};
var _default = InputPhone;
exports["default"] = _default;